import { create } from "zustand";

const snackbarStore = create((set) => ({
  isOpen: false,
  massage: "",

  setIsOpen: ({ value }) => {
    set({ isOpen: value });
  },

  setMassage: ({ value }) => {
    set({ massage: value });
  },
}));

export default snackbarStore;
